import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { environment } from '../../environments/environment';
import { DelphireUser } from '../interfaces/delphire-user';
import { Layout } from '../interfaces/layout';
import { Resource } from '../interfaces/resource';
import { Space } from '../interfaces/space';
import { DelphireApiService } from '../services/delphire-api.service';
import { DelphireLinkService } from '../services/delphire-link.service';
import { FirebaseService } from '../services/firebase.service';
import { LocalStorageService } from '../services/local-storage-service.service';

@Component({
  selector: 'app-deep-link',
  templateUrl: './deep-link.component.html',
  styleUrls: ['./deep-link.component.scss']
})
export class DeepLinkComponent implements OnInit {

  layouts: Layout[] = []
  space!: Space
  resource!: Resource
  resourceError: boolean = false

  constructor(
    private router: Router,
    private localStorage: LocalStorageService,
    private fb: FirebaseService,
    private linkService: DelphireLinkService,
    private route: ActivatedRoute,
    private delphireAPI: DelphireApiService
  ) {}

  ngOnInit(): void {
    this.openLink()
  }

  // ------------------------------------------------------------------

  async openLink(): Promise<void> {
    const user: DelphireUser = this.localStorage.get('delphireUser');
    const requestedPath: string = this.localStorage.get('requestedPath');
    const pathParts = requestedPath.split('/').filter(Boolean);

    let tenantId: string | undefined;
    let resourceId: string | undefined;
    console.log('%c DEEP LINK COMPONENT !pathParts!', 'background: red', pathParts)
    if (pathParts.length === 3) {
      // /:tenantId/:resourceId
      tenantId = pathParts[1];
      resourceId = pathParts[2];
    } else if (pathParts.length === 2) {
      // /:resourceId
      resourceId = pathParts[1];
    }

    // Find the correct tenant object
    const tenants = user?.tenants || [];
    let tenant = tenantId
      ? tenants.find((t: any) => t.id === tenantId)
      : tenants[0]; // fallback to first tenant if tenantId is not present

    if (!tenant) {
      console.error('Tenant not found');
      this.resourceError = true;
      return;
    }

    const databaseUrl = tenant.databaseUrl;
    this.space = this.localStorage.get('currentSpace');

    console.log('%c DEEP LINK COMPONENT', 'background: red')
    console.log('%c DEEP LINK COMPONENT user', 'background: red', user)
    console.log('%c DEEP LINK COMPONENT resourceId', 'background: red', resourceId)
    if (user && user.tenants && user.tenants.length > 0) { console.log('%c DEEP LINK COMPONENT user.tenants[0].databaseUrl', 'background: red', user.tenants[0].databaseUrl) }
    if (this.space) { console.log('%c DEEP LINK COMPONENT this.space', 'background: red', this.space) } else { console.log('%c DEEP LINK COMPONENT this.space', 'background: red', 'undefined') }
    // console.log('%c DEEP LINK COMPONENT this.space.databaseUrl', 'background: red', this.space.databaseUrl)
    console.log('%c DEEP LINK COMPONENT environment.firebasePaths.space', 'background: red', environment.firebasePaths.space)
    console.log('%c DEEP LINK COMPONENT fullPath', 'background: red', environment.firebasePaths.space + 'resources/' + resourceId)

    if (user && user.tenants && user.tenants.length > 0) {
      
      try {
        this.fb
          .db(databaseUrl)
          .object(environment.firebasePaths.space + 'resources/' + resourceId)
          .subscribe(async (data) => {
            const resource: Resource = data as Resource
            console.log('%c DEEP LINK COMPONENT resource', 'green: red', resource)
            this.resource = resource

            const { tenants } = this.localStorage.get('delphireUser')
            const newSpace: Space = _.find(tenants, (t) => {
              return true
            })
            this.localStorage.set('currentSpace', newSpace)
            console.log('%c DEEP LINK COMPONENT newSpace', 'background: red', newSpace)

            if(resource) {
              this.linkService.handleLink({
                type: resource.type,
                resource: resource,
                route: this.route
              })
            } else {

              console.log('%c DEEP LINK COMPONENT tenantId', 'background: green', tenantId)
              console.log('%c DEEP LINK COMPONENT resourceId', 'background: green', resourceId)
              console.log('%c DEEP LINK COMPONENT user.user.id', 'background: green', user.user.id)

              const link = await this.delphireAPI.postRequestPrisma(
                '/iam/getLaunchLink',
                {
                  tenantId: tenantId,
                  courseId: resourceId,
                  learnerId: user.user.id
                }
              )

              link.subscribe(async (res) => {
                console.log('res', res)

                if (res.body.error) {
                  console.log('%c DEEP LINK COMPONENT COURSE error', 'background: red', res.body.error)
                  this.resourceError = true
                } else {
                  window.open(res.body, '_blank')
                  
                  this.resource = res.body as Resource

                  // this.linkService.handleLink({
                  //   type: 'course',
                  //   id: resourceId,
                  //   route: this.route
                  // })
                }
              })

            }
          })
        } catch (error) {
          console.log('%c DEEP LINK COMPONENT error', 'background: red', error)
          this.resourceError = true
        }
    }
  }

  // ------------------------------------------------------------------

}
